import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';
import logoImage from '../../assets/icon_logo.png';

function Login() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await signIn(email, password);
      // Navigate to home page after successful login
      navigate('/');
    } catch (err) {
      console.error('Login failed:', err);
      let errorMessage = 'Login failed';

      if (err.code === 'UserNotConfirmedException') {
        errorMessage = 'Please verify your email before logging in';
        navigate('/verify-email', { state: { email } });
        return;
      } else if (err.code === 'NotAuthorizedException') {
        errorMessage = 'Incorrect email or password';
      } else if (err.code === 'UserNotFoundException') {
        errorMessage = 'No account found with this email';
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src={logoImage} alt="CoinedIn Logo" className="auth-logo" />
          <h1>CoinedIn</h1>
          <p className="auth-tagline">Recognize and Celebrate Success</p>
        </div>

        <form onSubmit={handleLogin} className="auth-form">
          <h2>Sign In</h2>

          {error && (
            <div className="auth-error">
              <span className="error-icon">⚠</span>
              <p>{error}</p>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <div className="auth-links">
            <button
              type="button"
              className="link-button"
              onClick={() => navigate('/forgot-password')}
              disabled={loading}
            >
              Forgot password?
            </button>
            <span className="separator">•</span>
            <button
              type="button"
              className="link-button"
              onClick={() => navigate('/signup')}
              disabled={loading}
            >
              Create account
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
